import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import './RemoveBasket.scss';
import { Button, EButtonType } from '@repo/apg-ui';

interface Props {
  basketId: string;
  basketreference: string;
  initName: string;
  onClose: any;
  onSuccess: any;
  removeBasket: any;
}

const RemoveBasketModal = ({ onClose, initName, removeBasket, basketId, basketreference }: Props) => {
  return (
    <div className='remove-basket-modal' id='root'>
      <div className='close-modal'>
        <Button onClick={onClose}>
          <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
          <RedxIcon />
        </Button>
      </div>
      <div className={'m-4 pt-24 d-flex flex-column'}>
        <p>
          <FormattedMessage
            id='ec.confirmation.removeConfirmation'
            defaultMessage='Wollen Sie den Warenkorb wirklich löschen?'
          />
        </p>
        <p>
          <b>{initName}</b>
        </p>
      </div>
      <div className={'m-4 d-flex justify-content-between'}>
        <Button onClick={onClose} buttonType={EButtonType.InvertedPillMedium}>
          <FormattedMessage id='ec.confirmation.no' defaultMessage='Nein' />
        </Button>
        <Button
          onClick={() => {
            removeBasket(basketId, basketreference).then(() => {
              onClose();
            });
          }}
          buttonType={EButtonType.PillMedium}
        >
          <FormattedMessage id='ec.confirmation.yes' defaultMessage='Ja' />
        </Button>
      </div>
    </div>
  );
};

export default RemoveBasketModal;
